import PageBanner from "../components/ui/PageBanner";
import wellnessImg from "../assets/about-wellness.jpeg";
import achieveImg from "../assets/about-achieve.jpeg";
import "./About.css";

const WHY_CHOOSE_US = [
  "24/7 Services",
  "Emergency Care",
  "Laboratory Services",
  "Radiology & Imaging",
  "Pharmacy",
  "Specialized Units",
  "Dialysis Unit",
  "Labor & Delivery Rooms",
  "Advanced ICU",
  "Neonatal Care",
  "Modern Equipment",
  "Diagnostic Radiology",
  "Diagnostic Laboratory",
  "Diagnostic Cardiology",
  "3 Modular OT & 1 Minor OT",
  "Expert Team",
  "100+ Doctors",
  "28 Departments",
  "Specialized Care",
  "Compassionate Staff",
];

const FACILITIES = [
  { title: "Advanced ICU", desc: "6-bed intensive care unit with 24/7 specialist coverage", cta: "Click for details \u2192" },
  { title: "Modern Laboratory", desc: "State-of-the-art lab with automated analyzers", cta: "Visit CDC Website" },
  { title: "Radiology & Imaging", desc: "CT Scan, MRI, X-Ray, and Ultrasound services", cta: "Visit CDC Website" },
  { title: "Private Rooms", desc: "Comfortable private and semi-private patient rooms", cta: "Click for details \u2192" },
  { title: "24/7 Emergency", desc: "Fully equipped emergency department with ambulance service", cta: "Click for details \u2192" },
  { title: "Modular OT", desc: "Advanced modular operating theaters", cta: "Visit CDC Website" },
  { title: "Dialysis Center", desc: "Modern dialysis unit with trained technicians", cta: "Click for details \u2192" },
  { title: "Blood Bank", desc: "Well-stocked blood bank with component separation", cta: "Click for details \u2192" },
  { title: "Pharmacy", desc: "24/7 in-house pharmacy with all medications", cta: "Visit CDC Website" },
  { title: "OPD Clinics", desc: "Multiple outpatient consultation rooms", cta: "Click for details \u2192" },
];

const CDC_URL = "https://cdc.net.pk/";

export default function AboutUs() {
  return (
    <div className="about-page">
      <PageBanner title="About Us" crumbs={["Home", "About Us"]} />

      {/* About Us */}
      <section className="section">
        <div className="section-inner">
          <div className="about__layout">
            <div>
              <p className="section-label">About Us</p>
              <h3 className="section-title">Capital Care International Hospital</h3>
              <p className="section-text">
                We are a modern healthcare facility dedicated to delivering compassionate, reliable, and advanced
                medical care. With a commitment to excellence, we combine state-of-the-art technology, highly skilled
                professionals, and patient-centered services.
              </p>
            </div>
            <div className="about__imgs">
              <div className="about__img-main">
                <img className="about__img" src={wellnessImg} alt="Capital Care International Hospital" loading="lazy" />
              </div>
              <div className="about__exp-badge">
                <span className="about__exp-num">24/7</span> Services
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Excellence */}
      <section className="section section--gray">
        <div className="section-inner">
          <div className="about__section-head">
            <p className="section-label">Our Excellence</p>
            <h3 className="section-title">Committed to providing world-class healthcare</h3>
            <p className="section-text">State-of-the-art facilities designed for superior patient care.</p>
          </div>

          <div className="about__stats-grid">
            {[
              { title: "55+", sub: "Total Beds" },
              { title: "100+", sub: "Expert Doctors" },
              { title: "6", sub: "ICU Beds" },
              { title: "3+1", sub: "Modular OT + Minor OT" },
              { title: "10", sub: "NICU Beds" },
            ].map((s) => (
              <div key={s.sub} className="about__stat-card card">
                <div className="about__stat-title">{s.title}</div>
                <div className="about__stat-sub">{s.sub}</div>
                <a className="about__stat-cta" href={CDC_URL} target="_blank" rel="noreferrer">
                  Click for details
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section">
        <div className="section-inner">
          <div className="about__layout">
            <div className="about__mission-img" aria-hidden="true">
              <img className="about__img" src={achieveImg} alt="" loading="lazy" />
            </div>
            <div>
              <p className="section-label">Why Choose Us</p>
              <h3 className="section-title">Experience comprehensive healthcare services</h3>
              <p className="section-text">Experience comprehensive healthcare services with cutting-edge technology</p>
              <div className="about__values-grid" style={{ marginTop: 14 }}>
                {WHY_CHOOSE_US.map((v) => (
                  <div key={v} className="about__value-item">
                    <span className="about__value-arrow">&gt;</span> {v}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* World-Class Facilities */}
      <section className="section section--gray">
        <div className="section-inner">
          <div className="about__section-head">
            <p className="section-label">World-Class Facilities</p>
            <h3 className="section-title">Modern infrastructure for superior patient care</h3>
            <p className="section-text">
              State-of-the-art medical equipment and modern infrastructure for superior patient care
            </p>
          </div>

          <div className="about__leadership-grid">
            {FACILITIES.map((f) => (
              <div key={f.title} className="card" style={{ padding: 18 }}>
                <h3 className="about__facility-title" style={{ marginBottom: 8 }}>
                  {f.title}
                </h3>
                <p className="section-text" style={{ marginBottom: 10 }}>
                  {f.desc}
                </p>
                <a className="about__card-cta" href={CDC_URL} target="_blank" rel="noreferrer">
                  {f.cta}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
